import * as React from "react";
const SvgFiBrandsLisp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-lisp_svg__a)">
      <path d="M20.492 3.522A11.9 11.9 0 0 0 16.586.911 11.9 11.9 0 0 0 11.978 0a11.95 11.95 0 0 0-4.577.916 11.9 11.9 0 0 0-3.88 2.592A11.93 11.93 0 0 0 0 11.991a11.92 11.92 0 0 0 3.508 8.488A11.92 11.92 0 0 0 11.991 24H12c3.202 0 6.212-1.245 8.478-3.508A11.92 11.92 0 0 0 24 12.009a11.91 11.91 0 0 0-3.508-8.487M12.091.302a11.63 11.63 0 0 1 8.187 3.433 11.62 11.62 0 0 1 3.42 8.275 11.62 11.62 0 0 1-3.433 8.269 5.75 5.75 0 0 1-4.089 1.692h-.005a5.75 5.75 0 0 1-4.09-1.698 5.75 5.75 0 0 1-1.692-4.093 5.75 5.75 0 0 1 1.698-4.09 6.06 6.06 0 0 0 1.79-4.313 6.06 6.06 0 0 0-1.784-4.316 6.25 6.25 0 0 0-4.394-1.826c-.557 0-1.107.077-1.639.229C7.852.821 9.915.285 12.091.302m-.95 6.554c-.282.555-.565 1.09-.84 1.61-2.057 3.887-3.691 6.972-.443 10.718H8.196c-2.218-3.608-4.013-7.101-5.538-12.327h1.746c.488 2.03 1.21 3.821 2.034 5.781l.121.288.112-.292c.652-1.692 1.549-3.873 2.733-5.778z" />
      <path d="M12.654 17.269h2.013c1.11-1.77 1.98-3.78 2.78-5.858.782 1.862 1.55 3.737 2.05 5.858h2.013c-1.487-5.15-3.242-8.693-5.635-12.58h-2.013c3.934 4.325 1.254 7.68-1.208 12.58" />
    </g>
    <defs>
      <clipPath id="fi-brands-lisp_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsLisp;
